import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { scrollToId } from "../lib/site";

function RouteEffects() {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    if (location.hash) {
      const timer = window.setTimeout(() => scrollToId(decodeURIComponent(location.hash.slice(1))), 80);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const timer = window.setTimeout(() => setAnnouncement(document.title), 180);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return <p className="sr-only" aria-live="polite" aria-atomic="true">{announcement}</p>;
}

export function Layout() {
  const { pathname } = useLocation();
  const hasMobileContactBar = pathname.startsWith("/property/");

  return (
    <>
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <RouteEffects />
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      {hasMobileContactBar && <div className="mobile-contact-spacer" aria-hidden="true" />}
    </>
  );
}
